export enum CompromiseStatusEnum {
    NotStarted = 0,
    InProgress = 1,
    Completed = 2,
    Deleted = 3
}